import {IWithSummaryModel} from '../../../../common/permission/api/entity/iWithSummary.model';
import {InsolesSummaryModel} from './insolesSummary.model';
import {InsoleDataModel} from "./data/insoleData.model";
import {Scan3dGroupSummaryModel} from "../../../scan3d/scanGroup/api/entity/scan3dGroupSummary.model";
import {
    ProviderServiceOptionSummaryModel
} from "../../../../provider/service/option/api/entity/providerServiceOptionSummary.model";

export class InsolesModel implements IWithSummaryModel<InsolesSummaryModel> {
    summary: InsolesSummaryModel;
    leftData: InsoleDataModel;
    rightData: InsoleDataModel;
    scanGroup: Scan3dGroupSummaryModel;
    options: ProviderServiceOptionSummaryModel[] = [];
}
